import { render } from "./ModelDocuments.vue?vue&type=template&id=889451a4"
import script from "./ModelDocuments.vue?vue&type=script&lang=js"
export * from "./ModelDocuments.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__